export default __webpack_public_path__ + "src/assets/home.bfd87229a1a3e5d43056314a6f674e51.svg";